@if (display && withShell) {
<astral-field-shell
  [control]="control"
  [forId]="resolvedInputId"
  [helpText]="helpText"
  [label]="resolvedLabel"
  [readonly]="resolvedReadonly"
  [disabled]="resolvedDisabled"
  [required]="resolvedRequired"
  [errorMessage]="errorMessage"
  [invalid]="invalid"
>
  <ng-container [ngTemplateOutlet]="dateInputTemplate"></ng-container>
</astral-field-shell>
} @else if (display) {
  <ng-container [ngTemplateOutlet]="dateInputTemplate"></ng-container>
}

<ng-template #dateInputTemplate>
  <div
    class="astral-date-picker"
    [class.astral-date-picker--readonly]="resolvedReadonly"
    [class.astral-date-picker--disabled]="resolvedDisabled"
    [class.astral-date-picker--focused]="isFocused"
  >
    <div class="astral-date-picker__actions">
      @if (showClearOthers) {
        <astral-field-action
        icon="clearOthers"
        titleKey="COMMON.CLEAR_OTHER_FILTERS"
        ariaLabelKey="COMMON.CLEAR_OTHER_FILTERS"
        (click)="clearAllOtherInputs()"
        ></astral-field-action>
      }

      @if (showClearThis) {
        <astral-field-action
        icon="clear"
        titleKey="COMMON.CLEAR"
        ariaLabelKey="COMMON.CLEAR"
        (click)="clearInput()"
        ></astral-field-action>
      }
    </div>

    <div class="astral-date-picker__control-shell" [class.astral-date-picker__control-shell--readonly]="resolvedReadonly">
      @if (resolvedReadonly) {
        <span class="astral-date-picker__readonly-icon" aria-hidden="true">
          <i [class]="readonlyIconClass"></i>
        </span>
      }

      <input
        #input
        astralFieldAccessibility
        [astralFieldControl]="rawControl"
        [astralFieldHelpText]="helpText"
        [astralFieldInputId]="resolvedInputId"
        [astralFieldInvalid]="invalid"
        [astralFieldRequired]="resolvedRequired"
        class="astral-date-picker__control"
        type="date"
        autocomplete="off"
        [attr.id]="resolvedInputId"
        [attr.name]="resolvedInputName"
        [value]="inputValue"
        [readonly]="resolvedReadonly ? true : null"
        [disabled]="resolvedDisabled ? true : null"
        [required]="resolvedRequired ? true : null"
        (input)="handleDateChange($any($event.target).value)"
        (focus)="handleFocus()"
        (blur)="handleBlur()"
      />
    </div>
  </div>
</ng-template>
